import * as v from "valibot";
v.setSpecificMessage(v.email, () => "Please enter a valid email address");

v.setSpecificMessage(
  v.minLength,
  (i) => `This field must be at least ${i.requirement} characters long`,
);

v.setSpecificMessage(
  v.maxLength,
  (i) => `This field must not be grater than ${i.requirement} characters`,
);

v.setSpecificMessage(v.nonEmpty, () => "This field cannot be empty");

v.setSpecificMessage(
  v.regex,
  () => "This field does not match the required format",
);
